import { useEffect, useState, useContext } from "react";
import { UserProfileContext } from "context/UserProfile";
import CheckIcon from "@mui/icons-material/Check";
import {
  Paper,
  Typography,
  Button,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import * as moment from "moment";
import { remainder_icon, Reminder } from "assets";

const ExpiryPopup = () => {
  const { data: uData } = useContext(UserProfileContext);
  const [show, setShow] = useState(false);
  const [remainingDays, setRemainingDays] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);

  const checkShouldShowPopup = () => {
    if (!uData) return false;
    if (uData?.role?.name !== "Admin") return false;

    const expiryDateStr = uData.organization?.config?.expirydate;
    if (!expiryDateStr) return false;
    const expiryDate = new Date(expiryDateStr);
    setExpiryDate(expiryDate);
    const now = new Date();
    const diffDays = Math.ceil((expiryDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    const dismissUntilStr = localStorage.getItem("expiryPopupDismissedUntil");
    const dismissUntil = dismissUntilStr ? parseInt(dismissUntilStr) : 0;
    const nowTime = now.getTime();

    const shouldShow =
      diffDays <= 7 && diffDays >= 0 && uData?.role?.name === "Admin" && nowTime > dismissUntil;

    if (shouldShow) {
      setRemainingDays(diffDays);
    }
    // else {
    //   localStorage.removeItem("expiryPopupDismissedUntil");
    // }

    return shouldShow;
  };

  useEffect(() => {
    if (checkShouldShowPopup()) {
      setShow(true);
    }

    const interval = setInterval(() => {
      if (checkShouldShowPopup()) {
        setShow(true);
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [uData]);
  const handleRemindLater = () => {
    setShow(false);
    const dismissUntil = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("expiryPopupDismissedUntil", dismissUntil.toString());
  };

  if (!show) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1300,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 3,
          maxWidth: 500,
          backgroundColor: "#fff",
          textAlign: "center",
          borderRadius: "10px",
        }}
      >
        <img src={remainder_icon} alt="remainder" width={55} />

        <Typography variant="subtitle1" gutterBottom>
          Dear <span style={{ color: "maroon" }}>{uData?.organization?.legalName}</span>,
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          YOUR SUBSCRIPTION ENDS IN{" "}
          <span style={{ color: "red", fontSize: "25px" }}>{remainingDays} DAYS</span>.
        </Typography>
        <Typography>Renew Now And You Can</Typography>
        <List dense>
          {[
            "Continue managing compliances seamlessly",
            "Avoid disruption in your workflow",
            "Retain access to your saved data & reports",
          ].map((text, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <Box
                  sx={{
                    backgroundColor: "green",
                    borderRadius: "50%",
                    width: 16,
                    height: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckIcon sx={{ color: "#fff", fontSize: 16 }} />
                </Box>
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
          {" "}
          <img src={Reminder} alt="remainder" width={15} />
          <Typography variant="body2">
            Renew Before:{" "}
            <span style={{ color: "#0060aa", fontWeight: "bold" }}>
              {moment(expiryDate).format("MMMM DD YYYY")}
            </span>
            .
          </Typography>
        </Box>

        <Box mt={2} display="flex" justifyContent="center" gap={2}>
          <Button variant="outlined" onClick={handleRemindLater} fullWidth>
            Remind Me Later
          </Button>
          <Button variant="contained" fullWidth>
            Contact Us
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ExpiryPopup;
